import FlowButton from './FlowButton'
import LockUnlockButton from './LockUnlockButton'
import { useAppContext } from '../contexts/AppContext'
import CopilotButton from './CopilotButton'
import AiTeammateListeningIndicator from './AiTeammateListeningIndicator'

/** Render the persistent Action Card header and its global controls. */
export default function Head() {
  const {
    data,
    update,
    settings: { hideFlow, hideLock },
  } = useAppContext()

  const handleLock = () => update(data, 'isLocked', !data.isLocked)

  return (
    <div
      className={
        'sticky z-10 top-0 grid w-full grid-cols-3 items-center bg-background @container ' +
        'group-data-[view=funnel]/app:left-0 group-data-[view=funnel]/app:w-(--slide-width)'
      }
    >
      <div className="justify-self-start">{!hideFlow && <FlowButton />}</div>

      <div className="justify-self-center">
        <AiTeammateListeningIndicator />
      </div>

      <div className="flex min-w-0 items-center gap-1 justify-self-end">
        <CopilotButton />
        {!hideLock && <LockUnlockButton isLocked={!!data.isLocked} onClick={handleLock} />}
      </div>
    </div>
  )
}
